import React from 'react';

import { Table } from '@backstage/core-components';

import { StorageFileshare } from '../hooks';

interface CardStorageFileshareProps {
  data?: StorageFileshare[];
}

const tableStyle: React.CSSProperties = {
  minWidth: '0',
  width: '100%',
  height: 'calc(100% - 10px)',
};

export const CardStorageFileshare = ({ data = [] }: CardStorageFileshareProps) => {
  const columns = [
    { title: 'Name', field: 'name' },
    { title: 'QuotaGB', field: 'quotaGB' },
  ];

  return (
    <Table
      title="Fileshare"
      columns={columns}
      data={data}
      style={tableStyle}
      options={{
        search: false,
        paging: false,
        loadingType: 'linear',
        maxBodyHeight: 500,
      }}
    />
  );
};
